import useMediaQuery from "@mui/material/useMediaQuery";

export const HookImports_useMediaQuery = useMediaQuery;

export const HookImports_useMediaQuery_theme = useMediaQuery;

